export default __webpack_public_path__ + "23139646dc359e0eb8e3ce4ae94a8fb0.svg";